import * as R from 'ramda';

export const domain = (typeof window === 'undefined') ? undefined : R.path(['_infl', 'hub', 'domain'], window);
export const subdomain = (typeof window === 'undefined') ? undefined : R.path(['_infl', 'hub', 'subdomain'], window);
export const environment = (typeof window === 'undefined') ? undefined : R.path(['_infl', 'environment'], window);
export const isAdmin = (typeof window === 'undefined') ? undefined : R.path(['_infl', 'currentContact', 'isAdmin'], window);
